const topics = [
  { label: '科幻大片', hot: true },
  { label: '悬疑烧脑', hot: true },
  { label: '动作爽片', hot: true },
  { label: '国产佳片', hot: false },
  { label: '豆瓣高分', hot: true },
  { label: '好莱坞精选', hot: false },
  { label: '日韩电影', hot: false },
  { label: '动画剧场', hot: false },
  { label: '纪录片', hot: false },
  { label: '4K专区', hot: true },
  { label: '本周新片', hot: true },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            大家都在关注这些电影话题，点击探索你的兴趣领域
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <span
              key={i}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium cursor-pointer transition-all duration-200 whitespace-nowrap border ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 border-primary-200 hover:bg-primary-200'
                  : 'bg-background-50 text-foreground-600 border-background-200/70 hover:border-foreground-300'
              }`}
            >
              {topic.hot && <i className="ri-fire-fill text-xs"></i>}
              {topic.label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}